<template>
  <Layout
    :assetType="assetType"
    :asset="asset"
    active="basic"
    :title="`Basic | ${assetType.name}`"
  >
    <!-- FORM -->
    <form @submit.prevent="fetchFormData" class="basic flex-grow-1 flex-column d-flex py-5 bg-light flex-shrink-0">
      <div class="flex-grow-1 flex-shrink-0">
        <div class="container">

            <MasterServiceAgreement
              v-if="assetType.slug === 'master-service-agreement'"
              @submitted="submit"
              :submitTrigger="submitTrigger"
              :asset="asset"
              :counterParties="counterParties"
              :organisations="organisations"
            />

            <WorkCategory
              v-if="assetType.slug === 'work-category'"
              @submitted="submit"
              :submitTrigger="submitTrigger"
              :asset="asset"
              :counterParties="counterParties"
              :organisations="organisations"

              :workCategories="workCategories"
            />

            <StatementOfWork
              v-if="assetType.slug === 'statement-of-work'"
              @submitted="submit"
              :submitTrigger="submitTrigger"
              :asset="asset"
              :counterParties="counterParties"
              :organisations="organisations"

              :workCategories="workCategories"
              :programmesOfWork="programmesOfWork"
            />

            <ChangeRequest
              v-if="assetType.slug === 'change-request'"
              @submitted="submit"
              :submitTrigger="submitTrigger"
              :asset="asset"
              :counterParties="counterParties"
              :organisations="organisations"
            />

            <UseTerms
              v-if="assetType.slug === 'clausify-use-terms'"
              @submitted="submit"
              :submitTrigger="submitTrigger"
              :asset="asset"
              :counterParties="counterParties"
              :organisations="organisations"
            />

            <NonDiscloserAgreement
              v-if="assetType.slug === 'non-disclosure-agreement'"
              @submitted="submit"
              :submitTrigger="submitTrigger"
              :asset="asset"
              :counterParties="counterParties"
              :organisations="organisations"
            />

            <OneNDA
              v-if="assetType.slug === 'one-nda'"
              @submitted="submit"
              :submitTrigger="submitTrigger"
              :asset="asset"
              :counterParties="counterParties"
              :organisations="organisations"
            />

            <FrameworkAgreement
              v-if="assetType.slug === 'framework-agreement'"
              @submitted="submit"
              :submitTrigger="submitTrigger"
              :asset="asset"
              :counterParties="counterParties"
              :organisations="organisations"
            />

            <FrameworkAgreementStatementOfWork
              v-if="assetType.slug === 'framework-agreement-sow'"
              @submitted="submit"
              :submitTrigger="submitTrigger"
              :asset="asset"
              :counterParties="counterParties"
              :organisations="organisations"
            />
        </div>
      </div>

      <div class="mt-4 flex-shrink-0">
        <div class="container">
          <div class="row">
            <div class="col-md-4 offset-md-4">
              <LoadingButton :loading="sending" class="btn btn-block btn-primary" type="submit">
                Edit {{ assetType.name }}
              </LoadingButton>
            </div>
          </div>
        </div>
      </div>

    </form>
  </Layout>
</template>

<script>
import LoadingButton from '@/Shared/LoadingButton.vue';
import Layout from './Layout.vue';

import MasterServiceAgreement from './Basic/MasterServiceAgreement.vue';
import WorkCategory from './Basic/WorkCategory.vue';
import StatementOfWork from './Basic/StatementOfWork.vue';
import ChangeRequest from './Basic/ChangeRequest.vue';
import UseTerms from './Basic/UseTerms.vue';
import NonDiscloserAgreement from './Basic/NonDiscloserAgreement.vue';
import OneNDA from './Basic/OneNDA.vue';
import FrameworkAgreement from './Basic/FrameworkAgreement.vue';
import FrameworkAgreementStatementOfWork from './Basic/FrameworkAgreementStatementOfWork.vue';

export default {
  components: {
    Layout,
    LoadingButton,
    MasterServiceAgreement,
    WorkCategory,
    StatementOfWork,
    ChangeRequest,
    UseTerms,
    NonDiscloserAgreement,
    OneNDA,
    FrameworkAgreement,
    FrameworkAgreementStatementOfWork,
  },

  props: {
    assetType: Object,
    asset: {
      type: Object,
      default: () => {},
    },
    counterParties: Array,
    organisations: Array,
    workCategories: Array,
    programmesOfWork: Array,
  },

  data() {
    return {
      submitTrigger: null,
      sending: false,
    };
  },

  methods: {
    fetchFormData() {
      this.sending = true;
      this.submitTrigger = Math.random().toString(36).substring(7);
    },

    submit(form) {
      if (this.asset) {
        this.$inertia.form(form).put(this.route('asset.basic.update', this.asset.id), {
          preserveScroll: true,
          onSuccess: () => {
            this.sending = false;
          },
          onError: () => {
            this.sending = false;
          },
        });
      } else {
        this.$inertia.form(form).post(this.route('asset.store', this.assetType.slug), {
          preserveScroll: true,
          onSuccess: () => {
            this.sending = false;
          },
          onError: () => {
            this.sending = false;
          },
        });
      }

    },
  },
};
</script>
